export const addressTranslation = {
  address: {
    IE: {
      "address.firstName": "First Name",
      "address.lastName": "Last Name",
      "address.company": "Company Name",
      "address.addressLine1": "Address line 1",
      "address.addressLine2": "Address line 2",
      "address.postalCode": "EIR Code",
      "address.city": "City/Town",
      "address.county": "County",
      "address.country": "Country",
      "address.phone": "Phone Number",
      "address.taxRegisterationNum": "Vat Registration Number",
      "address.select": "Select",

      "address.error_firstName": "Only alphabets are allowed for First Name",
      "address.error_lastName": "Only alphabets are allowed for Last Name",
      "address.error_company":
        "Only alphabets, Number and spaces are allowed for Company Name",
      "address.error_addressLine1":
        "Only alphabets, Number, spaces and commas are allowed for Address line 1",
      "address.error_addressLine2":
        "Only alphabets, Number, spaces and commas are allowed for Address line 2",
      "address.error_postalCode":
        "Only alphabets and Numbers are allowed for EIR Code",
      "address.error_city":
        "Only alphabets and spaces are allowed for City/Town",
      "address.error_county": "Only alphabets are allowed for County",
      "address.error_country":
        "Only alphabets and spaces are allowed for Country",
      "address.error_phone":
        "Please enter a valid phone number. Only numbers allowed.",
      "address.error_taxRegisterationNum":
        "Only alphabets and Numbers are allowed for Vat Registeration Number",
    },
    JP: {
      "address.firstName": "名",
      "address.lastName": "姓",
      "address.company": "会社名",
      "address.addressLine1": "住所1",
      "address.addressLine2": "住所2",
      "address.postalCode": "郵便番号",
      "address.city": "市区町村",
      "address.county": "都道府県",
      "address.country": "国",
      "address.phone": "電話番号",
      "address.taxRegisterationNum": "VAT登録番号",
      "address.select": "選択",

      "address.error_firstName": "名にはアルファベットのみ使用できます。",
      "address.error_lastName": "姓にはアルファベットのみ使用できます。",
      "address.error_company":
        "会社名にはアルファベット、数字、スペースのみ使用できます。",
      "address.error_addressLine1":
        "住所1にはアルファベット、数字、スペース、コンマのみ使用できます。",
      "address.error_addressLine2":
        "住所2にはアルファベット、数字、スペース、コンマのみ使用できます。",
      "address.error_postalCode":
        "郵便番号にはアルファベット、数字のみ使用できます。",
      "address.error_city": "市町村にはアルファベットのみ使用できます。",
      "address.error_county": "県にはアルファベットのみ使用できます。",
      "address.error_country": "国にはアルファベットのみ使用できます。",
      "address.error_phone":
        "電話番号には数字のみ使用でき、最小文字数は10文字です。",
      "address.error_taxRegisterationNum":
        "VAT登録番号にはアルファベット、数字のみ使用できます。",
    },
    PT: {
      "address.firstName": "Nome",
      "address.lastName": "Sobrenome",
      "address.company": "Nome da empresa",
      "address.addressLine1": "1º Morada",
      "address.addressLine2": "2º Morada",
      "address.postalCode": "Codigo Postal",
      "address.city": "Cidade/Vila",
      "address.county": "município",
      "address.country": "País",
      "address.phone": "Numero de telefone",
      "address.taxRegisterationNum": "Número do IVA",
      "address.select": "Selecione",

      "address.error_firstName":
        "Somente alfabetos são permitidos para o primeiro nome",
      "address.error_lastName":
        "Somente alfabetos são permitidos para o sobrenome",
      "address.error_company":
        "Somente alfabetos, números e espaços são permitidos para o nome da empresa",
      "address.error_addressLine1":
        "Somente alfabetos, números, espaços e vírgulas são permitidos para a linha de endereço 1",
      "address.error_addressLine2":
        "Somente alfabetos, números, espaços e vírgulas são permitidos para a linha de endereço 2",
      "address.error_postalCode":
        "Somente alfabetos e números são permitidos para o código EIR",
      "address.error_city":
        "Somente alfabetos e espaços são permitidos para Cidade / Cidade",
      "address.error_county": "Somente alfabetos são permitidos para o Condado",
      "address.error_country":
        "Apenas alfabetos e espaços são permitidos para o país",
      "address.error_phone":
        "Por favor entre um numero de telefone válido. Apenas são permitidos algarismos.",
      "address.error_taxRegisterationNum":
        "Somente alfabetos e números são permitidos para o número de IVA",
    },
    ES: {
      "address.firstName": "Nombre",
      "address.lastName": "Apellido",
      "address.company": "Nombre de empresa",
      "address.addressLine1": "Dirección Línea 1",
      "address.addressLine2": "Dirección Línea 2",
      "address.postalCode": "Código postal",
      "address.city": "Ciudad / pueblo",
      "address.county": "Provincia",
      "address.country": "País",
      "address.phone": "Número de teléfono",
      "address.taxRegisterationNum": "Número de identificación fiscal",
      "address.select": "Seleccionar",

      "address.error_firstName": "Solo se permiten alfabetos para el nombre",
      "address.error_lastName": "Solo se permiten alfabetos para el Apellido",
      "address.error_company":
        "Solo se permiten alfabetos, números y espacios para el nombre de la empresa",
      "address.error_addressLine1":
        "Solo se permiten alfabetos, números, espacios y comas para la línea de dirección 1",
      "address.error_addressLine2":
        "Solo se permiten alfabetos, números, espacios y comas para la línea de dirección 2",
      "address.error_postalCode":
        "Solo se permiten alfabetos y números para el Código EIR",
      "address.error_city":
        "Solo se permiten alfabetos y espacios para Ciudad / Pueblo",
      "address.error_county": "Solo se permiten alfabetos para el Condado",
      "address.error_country":
        "Solo se permiten alfabetos y espacios por país.",
      "address.error_phone":
        "Por favor ingrese un número de teléfono válido. Solo números permitidos.",
      "address.error_taxRegisterationNum":
        "Solo se permiten alfabetos y números para el Número de registro de Vat",
    },
    "fr-BE": {
      "address.firstName": "Prénom",
      "address.lastName": "Nom de famille",
      "address.company": "Nom de la compagnie",
      "address.addressLine1": "Adresse 1",
      "address.addressLine2": "Adresse 2",
      "address.postalCode": "Code postal",
      "address.city": "Ville",
      "address.county": "Comté",
      "address.country": "Pays",
      "address.phone": "Numéro de téléphone",
      "address.taxRegisterationNum": "Numéro d'enregistrement de TVA",
      "address.select": "Sélectionner",

      "address.error_firstName":
        "Seuls les alphabets sont autorisés pour Prénom",
      "address.error_lastName":
        "Seuls les alphabets sont autorisés pour le nom de famille",
      "address.error_company":
        "Seuls les alphabets, le nombre et les espaces sont autorisés pour Nom de la société",
      "address.error_addressLine1":
        "Seuls les alphabets, le nombre, les espaces et les virgules sont autorisés pour la ligne d'adresse 1",
      "address.error_addressLine2":
        "Seuls les alphabets, le nombre, les espaces et les virgules sont autorisés pour la ligne d'adresse 2",
      "address.error_postalCode":
        "Seuls les alphabets et les chiffres sont autorisés pour le code postal",
      "address.error_city":
        "Seuls les alphabets et les espaces sont autorisés pour Ville",
      "address.error_county":
        "Seuls les alphabets sont autorisés pour le comté",
      "address.error_country":
        "Seuls les alphabets et les espaces sont autorisés pour Pays",
      "address.error_phone":
        "Veuillez entrer un numéro de telephone valide. Seuls les chiffres sont autorisés.",
      "address.error_taxRegisterationNum":
        "Seuls les alphabets et les chiffres sont autorisés pour le numéro d'enregistrement de TVA",
    },
    "nl-BE": {
      "address.firstName": "Voornaam",
      "address.lastName": "Achternaam",
      "address.company": "Bedrijfsnaam",
      "address.addressLine1": "Adres regel 1",
      "address.addressLine2": "Adres regel 2",
      "address.postalCode": "Postcode",
      "address.city": "Stad / plaats",
      "address.county": "Provincie",
      "address.country": "land",
      "address.phone": "Telefoonnummer",
      "address.taxRegisterationNum": "VAT registratie nummer",
      "address.select": "kiezen",

      "address.error_firstName":
        "Alleen alfabetten zijn toegestaan voor Voornaam",
      "address.error_lastName":
        "Alleen alfabetten zijn toegestaan voor Achternaam",
      "address.error_company":
        "Alleen alfabetten, aantal en spaties zijn toegestaan voor bedrijfsnaam",
      "address.error_addressLine1":
        "Alleen alfabetten, aantal, spaties en komma's zijn toegestaan voor adresregel 1",
      "address.error_addressLine2":
        "Alleen alfabetten, aantal, spaties en komma's zijn toegestaan voor adresregel 2",
      "address.error_postalCode":
        "Alleen letters en cijfers zijn toegestaan voor Postcode",
      "address.error_city":
        "Alleen letters en spaties zijn toegestaan voor Stad / Gemeente",
      "address.error_county": "Alleen alfabetten zijn toegestaan voor County",
      "address.error_country":
        "Alleen letters en spaties zijn toegestaan voor Land",
      "address.error_phone":
        "Gelieve een correct telefoonnummer in te voeren. Alleen cijfers toegestaan.",
      "address.error_taxRegisterationNum":
        "Alleen alfabetten en nummers zijn toegestaan voor btw-registratienummer",
    },
    "en-GB": {
      "address.firstName": "First Name",
      "address.lastName": "Last Name",
      "address.company": "Company Name",
      "address.addressLine1": "Address line 1",
      "address.addressLine2": "Address line 2",
      "address.postalCode": "Postal Code",
      "address.city": "City/Town",
      "address.county": "County",
      "address.country": "Country",
      "address.phone": "Phone Number",
      "address.taxRegisterationNum": "Vat Registration Number",
      "address.select": "Select",

      "address.error_firstName": "Only alphabets are allowed for First Name",
      "address.error_lastName": "Only alphabets are allowed for Last Name",
      "address.error_company":
        "Only alphabets, Number and spaces are allowed for Company Name",
      "address.error_addressLine1":
        "Only alphabets, Number, spaces and commas are allowed for Address line 1",
      "address.error_addressLine2":
        "Only alphabets, Number, spaces and commas are allowed for Address line 2",
      "address.error_postalCode":
        "Only alphabets and Numbers are allowed for Postal Code",
      "address.error_city":
        "Only alphabets and spaces are allowed for City/Town",
      "address.error_county": "Only alphabets are allowed for County",
      "address.error_country":
        "Only alphabets and spaces are allowed for Country",
      "address.error_phone":
        "Please enter a valid phone number. Only numbers allowed.",
      "address.error_taxRegisterationNum":
        "Only alphabets and Numbers are allowed for Vat Registeration Number",
    },
    "fr-CH": {
      "address.firstName": "Prénom",
      "address.lastName": "Nom de famille",
      "address.company": "Nom de la compagnie",
      "address.addressLine1": "Adresse 1",
      "address.addressLine2": "Adresse 2",
      "address.postalCode": "Code postal",
      "address.city": "Ville",
      "address.clientNumber": "Numéro de client",
      "address.county": "Comté",
      "address.country": "Pays",
      "address.phone": "Numéro de téléphone",
      "address.taxRegisterationNum": "Numéro d'enregistrement de TVA",
      "address.select": "Sélectionner",

      "address.error_firstName":
        "Seuls les alphabets sont autorisés pour Prénom",
      "address.error_lastName":
        "Seuls les alphabets sont autorisés pour le nom de famille",
      "address.error_company":
        "Seuls les alphabets, le nombre et les espaces sont autorisés pour Nom de la société",
      "address.error_addressLine1":
        "Seuls les alphabets, le nombre, les espaces et les virgules sont autorisés pour la ligne d'adresse 1",
      "address.error_addressLine2":
        "Seuls les alphabets, le nombre, les espaces et les virgules sont autorisés pour la ligne d'adresse 2",
      "address.error_postalCode":
        "Seuls les alphabets et les chiffres sont autorisés pour le code postal",
      "address.error_city":
        "Seuls les alphabets et les espaces sont autorisés pour Ville",
      "address.error_county":
        "Seuls les alphabets sont autorisés pour le comté",
      "address.error_country":
        "Seuls les alphabets et les espaces sont autorisés pour Pays",
      "address.error_phone":
        "Veuillez entrer un numéro de telephone valide. Seuls les chiffres sont autorisés.",
      "address.error_taxRegisterationNum":
        "Seuls les alphabets et les chiffres sont autorisés pour le numéro d'enregistrement de TVA",
    },
    "de-CH": {
      "address.firstName": "Vorname",
      "address.lastName": "Nachname",
      "address.company": "Firmenname",
      "address.addressLine1": "Straße und Hausnummer",
      "address.addressLine2": "Straße und Hausnummer 2",
      "address.postalCode": "Postleitzahl",
      "address.city": "Ort",
      "address.clientNumber": "Kundennummer",
      "address.county": "Bezirk",
      "address.country": "Land",
      "address.phone": "Kontakt-Telefonnummer",
      "address.taxRegisterationNum": "VAT Registrierungsnummer",
      "address.select": "Wählen",

      "address.error_firstName": "Für Vorname sind nur Alphabete zulässig",
      "address.error_lastName": "Für Nachname sind nur Alphabete zulässig",
      "address.error_company":
        "Es sind nur Alphabete, Zahlen und Leerzeichen für den Firmennamen zulässig",
      "address.error_addressLine1":
        "Für die Adresszeile 1 sind nur Buchstaben, Zahlen, Leerzeichen und Kommas zulässig",
      "address.error_addressLine2":
        "Für die Adresszeile 2 sind nur Buchstaben, Zahlen, Leerzeichen und Kommas zulässig",
      "address.error_postalCode":
        "Für den Postleitzahl sind nur Buchstaben und Zahlen erlaubt",
      "address.error_city":
        "Für die Stadt sind nur Buchstaben und Leerzeichen zulässig",
      "address.error_county": "Für County sind nur Alphabete erlaubt",
      "address.error_country":
        "Für Land sind nur Alphabete und Leerzeichen zulässig",
      "address.error_phone":
        "Bitte geben Sie eine gültige Telefonnummer ein. Bitte nur Zahlen eingeben.",
      "address.error_taxRegisterationNum":
        "Für die Mehrwertsteuer-Registrierungsnummer sind nur Alphabete und Nummern zulässig",
    },
    "it-CH": {
      "address.firstName": "Nome",
      "address.lastName": "Cognome",
      "address.company": "Nome dell'azienda",
      "address.addressLine1": "Indirizzo Riga 1",
      "address.addressLine2": "Indirizzo Riga 2",
      "address.postalCode": "Codice postale",
      "address.city": "Città/paese",
      "address.clientNumber": "Codice cliente",
      "address.county": "Provincia",
      "address.country": "Paese",
      "address.phone": "Numero di telefono",
      "address.taxRegisterationNum": "Numero di Partita Iva",
      "address.select": "Seleziona",

      "address.error_firstName":
        "Per il Nome sono ammesse soltanto lettere. Inserisci un Nome valido.",
      "address.error_lastName":
        "Per il Cognome sono ammesse soltanto lettere. Inserisci un Cognome valido.",
      "address.error_company":
        "Per il Nome dell’azienda sono ammessi soltanto lettere, numeri e spazi",
      "address.error_addressLine1":
        "Per la riga 1 dell'Indirizzo sono ammessi soltanto lettere, numeri, spazi e virgole",
      "address.error_addressLine2":
        "Per la riga 2 dell'Indirizzo sono ammessi soltanto lettere, numeri, spazi e virgole",
      "address.error_postalCode":
        "Per il Codice postale sono ammessi soltanto lettere e numeri",
      "address.error_city":
        "Per Città/paese sono ammessi soltanto lettere e spazi",
      "address.error_county": "SPer la Regione sono ammesse soltanto lettere.",
      "address.error_country":
        "Per il Paese sono ammessi soltanto lettere e spazi",
      "address.error_phone":
        "Si prega di inserire un numero di telefono valido. Sono ammessi solo numeri.",
      "address.error_taxRegisterationNum":
        "Per il Numero di Partita Iva sono ammessi soltanto lettere e numeri",
    },
    "nl-NL": {
      "address.firstName": "Voornaam",
      "address.lastName": "Achternaam",
      "address.company": "Bedrijfsnaam",
      "address.addressLine1": "Adres regel 1",
      "address.addressLine2": "Adres regel 2",
      "address.postalCode": "Postcode",
      "address.city": "Stad / plaats",
      "address.county": "Provincie",
      "address.country": "land",
      "address.phone": "Telefoonnummer",
      "address.taxRegisterationNum": "VAT registratie nummer",
      "address.select": "kiezen",

      "address.error_firstName":
        "Alleen alfabetten zijn toegestaan voor Voornaam",
      "address.error_lastName":
        "Alleen alfabetten zijn toegestaan voor Achternaam",
      "address.error_company":
        "Alleen alfabetten, aantal en spaties zijn toegestaan voor bedrijfsnaam",
      "address.error_addressLine1":
        "Alleen alfabetten, aantal, spaties en komma's zijn toegestaan voor adresregel 1",
      "address.error_addressLine2":
        "Alleen alfabetten, aantal, spaties en komma's zijn toegestaan voor adresregel 2",
      "address.error_postalCode":
        "Alleen letters en cijfers zijn toegestaan voor Postcode",
      "address.error_city":
        "Alleen letters en spaties zijn toegestaan voor Stad / Gemeente",
      "address.error_county": "Alleen alfabetten zijn toegestaan voor County",
      "address.error_country":
        "Alleen letters en spaties zijn toegestaan voor Land",
      "address.error_phone":
        "Gelieve een correct telefoonnummer in te voeren. Alleen cijfers toegestaan.",
      "address.error_taxRegisterationNum":
        "Alleen alfabetten en nummers zijn toegestaan voor btw-registratienummer",
    },
    "fr-FR": {
      "address.firstName": "Prénom",
      "address.lastName": "Nom",
      "address.company": "Société",
      "address.addressLine1": "Adresse ligne 1",
      "address.addressLine2": "Adresse ligne 2",
      "address.postalCode": "Code postal",
      "address.city": "Ville",
      "address.clientNumber": "Numéro de client",
      "address.county": "Comté",
      "address.country": "Pays",
      "address.phone": "Numéro de téléphone",
      "address.taxRegisterationNum": "Numéro de TVA",
      "address.select": "Sélectionner",

      "address.error_firstName":
        "Seuls les alphabets sont autorisés pour Prénom",
      "address.error_lastName":
        "Seuls les alphabets sont autorisés pour le nom de famille",
      "address.error_company":
        "Seuls les alphabets, le nombre et les espaces sont autorisés pour Nom de la société",
      "address.error_addressLine1":
        "Seuls les alphabets, le nombre, les espaces et les virgules sont autorisés pour la ligne d'adresse 1",
      "address.error_addressLine2":
        "Seuls les alphabets, le nombre, les espaces et les virgules sont autorisés pour la ligne d'adresse 2",
      "address.error_postalCode":
        "Seuls les alphabets et les chiffres sont autorisés pour le code postal",
      "address.error_city":
        "Seuls les alphabets et les espaces sont autorisés pour Ville",
      "address.error_county":
        "Seuls les alphabets sont autorisés pour le comté",
      "address.error_country":
        "Seuls les alphabets et les espaces sont autorisés pour Pays",
      "address.error_phone":
        "Veuillez entrer un numéro de telephone valide. Seuls les chiffres sont autorisés.",
      "address.error_taxRegisterationNum":
        "Seuls les alphabets et les chiffres sont autorisés pour le numéro d'enregistrement de TVA",
    },
    "de-DE": {
      "address.firstName": "Vorname",
      "address.lastName": "Nachname",
      "address.company": "Firmenname",
      "address.addressLine1": "Straße und Hausnummer",
      "address.addressLine2": "Straße und Hausnummer 2",
      "address.postalCode": "Postleitzahl",
      "address.city": "Ort",
      "address.clientNumber": "Kundennummer",
      "address.county": "Bezirk",
      "address.country": "Land",
      "address.phone": "Kontakt-Telefonnummer",
      "address.taxRegisterationNum": "VAT Registrierungsnummer",
      "address.select": "Wählen",

      "address.error_firstName": "Für Vorname sind nur Alphabete zulässig",
      "address.error_lastName": "Für Nachname sind nur Alphabete zulässig",
      "address.error_company":
        "Es sind nur Alphabete, Zahlen und Leerzeichen für den Firmennamen zulässig",
      "address.error_addressLine1":
        "Für die Adresszeile 1 sind nur Buchstaben, Zahlen, Leerzeichen und Kommas zulässig",
      "address.error_addressLine2":
        "Für die Adresszeile 2 sind nur Buchstaben, Zahlen, Leerzeichen und Kommas zulässig",
      "address.error_postalCode":
        "Für den Postleitzahl sind nur Buchstaben und Zahlen erlaubt",
      "address.error_city":
        "Für die Stadt sind nur Buchstaben und Leerzeichen zulässig",
      "address.error_county": "Für County sind nur Alphabete erlaubt",
      "address.error_country":
        "Für Land sind nur Alphabete und Leerzeichen zulässig",
      "address.error_phone":
        "Bitte geben Sie eine gültige Telefonnummer ein. Bitte nur Zahlen eingeben.",
      "address.error_taxRegisterationNum":
        "Für die Mehrwertsteuer-Registrierungsnummer sind nur Alphabete und Nummern zulässig",
    },
    "it-IT": {
      "address.firstName": "Nome",
      "address.lastName": "Cognome",
      "address.company": "Nome dell'azienda",
      "address.addressLine1": "Indirizzo Riga 1",
      "address.addressLine2": "Indirizzo Riga 2",
      "address.postalCode": "Codice postale",
      "address.city": "Città/paese",
      "address.clientNumber": "Codice cliente",
      "address.county": "Provincia",
      "address.country": "Paese",
      "address.phone": "Numero di telefono",
      "address.taxRegisterationNum": "Numero di Partita Iva",
      "address.select": "Seleziona",

      "address.error_firstName":
        "Per il Nome sono ammesse soltanto lettere. Inserisci un Nome valido.",
      "address.error_lastName":
        "Per il Cognome sono ammesse soltanto lettere. Inserisci un Cognome valido.",
      "address.error_company":
        "Per il Nome dell’azienda sono ammessi soltanto lettere, numeri e spazi",
      "address.error_addressLine1":
        "Per la riga 1 dell'Indirizzo sono ammessi soltanto lettere, numeri, spazi e virgole",
      "address.error_addressLine2":
        "Per la riga 2 dell'Indirizzo sono ammessi soltanto lettere, numeri, spazi e virgole",
      "address.error_postalCode":
        "Per il Codice postale sono ammessi soltanto lettere e numeri",
      "address.error_city":
        "Per Città/paese sono ammessi soltanto lettere e spazi",
      "address.error_county": "SPer la Regione sono ammesse soltanto lettere.",
      "address.error_country":
        "Per il Paese sono ammessi soltanto lettere e spazi",
      "address.error_phone":
        "Si prega di inserire un numero di telefono valido. Sono ammessi solo numeri.",
      "address.error_taxRegisterationNum":
        "Per il Numero di Partita Iva sono ammessi soltanto lettere e numeri",
    },
    "de-AT": {
      "address.firstName": "Vorname",
      "address.lastName": "Nachname",
      "address.company": "Firmenname",
      "address.addressLine1": "Straße und Hausnummer",
      "address.addressLine2": "Straße und Hausnummer 2",
      "address.postalCode": "Postleitzahl",
      "address.city": "Ort",
      "address.clientNumber": "Kundennummer",
      "address.county": "Bezirk",
      "address.country": "Land",
      "address.phone": "Kontakt-Telefonnummer",
      "address.taxRegisterationNum": "VAT Registrierungsnummer",
      "address.select": "Wählen",

      "address.error_firstName": "Für Vorname sind nur Alphabete zulässig",
      "address.error_lastName": "Für Nachname sind nur Alphabete zulässig",
      "address.error_company":
        "Es sind nur Alphabete, Zahlen und Leerzeichen für den Firmennamen zulässig",
      "address.error_addressLine1":
        "Für die Adresszeile 1 sind nur Buchstaben, Zahlen, Leerzeichen und Kommas zulässig",
      "address.error_addressLine2":
        "Für die Adresszeile 2 sind nur Buchstaben, Zahlen, Leerzeichen und Kommas zulässig",
      "address.error_postalCode":
        "Für den Postleitzahl sind nur Buchstaben und Zahlen erlaubt",
      "address.error_city":
        "Für die Stadt sind nur Buchstaben und Leerzeichen zulässig",
      "address.error_county": "Für County sind nur Alphabete erlaubt",
      "address.error_country":
        "Für Land sind nur Alphabete und Leerzeichen zulässig",
      "address.error_phone":
        "Bitte geben Sie eine gültige Telefonnummer ein. Bitte nur Zahlen eingeben.",
      "address.error_taxRegisterationNum":
        "Für die Mehrwertsteuer-Registrierungsnummer sind nur Alphabete und Nummern zulässig",
    },
    "sv-SE": {
      "address.firstName": "Förnamn",
      "address.lastName": "Efternamn",
      "address.company": "Företagsnamn",
      "address.addressLine1": "Adress 1",
      "address.addressLine2": "Adress 2",
      "address.postalCode": "Post Kod",
      "address.city": "Stad",
      "address.county": "Kommun",
      "address.country": "Land",
      "address.phone": "Telefon",
      "address.taxRegisterationNum": "Moms registrerings Nummer",
      "address.select": "Var god välj land",

      "address.error_firstName": "Bara bokstäver är tillåtna för förnamn",
      "address.error_lastName": "Bara bokstäver är tillåtna för efternamn",
      "address.error_company":
        "Bara bokstäver, mellanslag och siffror är tillåtna för företagsnamn",
      "address.error_addressLine1":
        "Bara bokstäver, mellanslag, komma och siffror är  tillåtna för adress 1",
      "address.error_addressLine2":
        "Bara bokstäver, mellanslag, komma och siffror är  tillåtna för adress 2",
      "address.error_postalCode":
        "Bara bokstäver och siffrior är tiillåtna för Irländska postnummer",
      "address.error_city": "Bara bokstäver är tillåtna för namnet på staden",
      "address.error_county": "Bara bokstäver ä tillåtna för county",
      "address.error_country":
        "Bara bokstäver och mellanslag är tillåtna för land",
      "address.error_phone":
        "Var vänlig och slå in ett giltigt telefonnummer. Endast siffror tillåtna. ",
      "address.error_taxRegisterationNum":
        "Bara boktstäver och siffror är tillåtna för moms registrerings nummer",
    },
    DK: {
      "address.firstName": "Fornavn",
      "address.lastName": "Efternavn",
      "address.company": "Firmanavn",
      "address.addressLine1": "Adresselinje 1",
      "address.addressLine2": "Adresselinje 2",
      "address.postalCode": "Postnummer",
      "address.city": "By",
      "address.county": "Landsdel",
      "address.country": "Land",
      "address.phone": "Telefonnummer",
      "address.taxRegisterationNum": "Momsregistreringsnummer",
      "address.select": "Vælg",

      "address.error_firstName":
        "Kun bogstaver er tilladt for fornavne. Indtast venligst et gyldigt fornavn.",
      "address.error_lastName":
        "Kun bogstaver er tilladt for efternavne. Indtast venligst et gyldigt efternavn.",
      "address.error_company":
        "Kun bogstaver, tal og mellemrum er tilladt for firmanavne.",
      "address.error_addressLine2":
        "Kun bogstaver, tal, mellemrum og kommaer er tilladt for adresselinje 2",
      "address.error_postalCode":
        "Kun bogstaver og tal er tilladt som EIR kode",
      "address.error_city": "Kun bogstaver og mellemrum er tilladt for byer",
      "address.error_county":
        "Kun bogstaver og mellemrum er tilladt for landsdele",
      "address.error_country": "Kun bogstaver og mellemrum er tilladt for land",
      "address.error_phone":
        "Venligst indtast et gyldigt telefonnummer. Kun tal er tilladt.",
      "address.error_taxRegisterationNum":
        "Kun bogstaver og tal er tilladt ved momsregistreringsnumre",
    },
    "nn-NO": {
      "address.firstName": "Fornavn",
      "address.lastName": "Etternavn",
      "address.company": "Selskapets navn",
      "address.addressLine1": "Adresse linje 1",
      "address.addressLine2": "Adresse linje 2",
      "address.postalCode": "Postkode",
      "address.city": "By",
      "address.county": "Fylke",
      "address.country": "Land",
      "address.phone": "Telefonnummer",
      "address.taxRegisterationNum": "MVA-registreringsnummer",
      "address.select": "Velg",

      "address.error_firstName":
        "Bare bokstaver tillatt for Fornavn. Vennligst skriv inn et gyldig Fornavn",
      "address.error_lastName":
        "Bare bokstaver tillatt for Etternavn. Vennligst skriv inn et gyldig Etternavn.",
      "address.error_company":
        "Bare bokstaver, tall og mellomrom er tillatt for Selskapsnavn",
      "address.error_addressLine1":
        "Bare bokstaver, tall, mellomrom og komma er tillatt for Adresselinje 1",
      "address.error_addressLine2":
        "Bare bokstaver, tall, mellomrom og komma er tillatt for Adresselinje 2",
      "address.error_postalCode":
        "Bare bokstaver og tall er tillatt for Postkode",
      "address.error_city":
        "Bare bokstaver og mellomrom er tillatt for By / Sted",
      "address.error_county": "Bare bokstaver er tillatt for Fylke",
      "address.error_country":
        "Bare bokstaver og mellomrom er tillatt for Land",
      "address.error_phone":
        "Bare tall er tillatt for telefonnummer og minimum lengde bør være 8.",
      "address.error_taxRegisterationNum":
        "Bare bokstaver og tall er tillatt for MVA-nummer",
    },
    CZ: {
      "address.firstName": "Křestní jméno",
      "address.lastName": "Příjmení",
      "address.company": "Název firmy",
      "address.addressLine1": "1. řádek adresy",
      "address.addressLine2": "2. řádek adresy",
      "address.postalCode": "PSČ",
      "address.city": "Město",
      "address.county": "Okres",
      "address.country": "Země",
      "address.phone": "Telefonní číslo",
      "address.taxRegisterationNum": "DIČ",
      "address.select": "Vybrat",

      "address.error_firstName": "Křestní jméno smí obsahovat pouze písmena.",
      "address.error_lastName": "Příjmení smí obsahovat pouze písmena.",
      "address.error_company":
        "Název společnosti smí obsahovat pouze písmena, číslice a mezery.",
      "address.error_addressLine1":
        "1. řádek adresy smí obsahovat pouze písmena, číslice, mezery a čárky.",
      "address.error_addressLine2":
        "2. řádek adresy smí obsahovat pouze písmena, číslice, mezery a čárky.",
      "address.error_postalCode":
        "Kód EIR smí obsahovat pouze písmena a číslice.",
      "address.error_city": "Město smí obsahovat pouze písmena a mezery.",
      "address.error_county": "Okres smí obsahovat pouze písmena.",
      "address.error_country": "Země smí obsahovat pouze písmena a mezery.",
      "address.error_phone":
        "Prosím, zadejte platné telefonní číslo. Jsou povolené pouze číslice.",
      "address.error_taxRegisterationNum":
        "DIČ smí obsahovat pouze písmena a číslice.",
    },
    "en-NZ": {
      "address.firstName": "First Name",
      "address.lastName": "Last Name",
      "address.company": "Company Name",
      "address.addressLine1": "Address line 1",
      "address.addressLine2": "Address line 2",
      "address.postalCode": "Postcode",
      "address.city": "City/Town",
      "address.county": "Suburb",
      "address.country": "Country",
      "address.phone": "Phone Number",
      "address.taxRegisterationNum": "Vat Registration Number",
      "address.select": "Select",

      "address.error_firstName": "Only alphabets are allowed for First Name",
      "address.error_lastName": "Only alphabets are allowed for Last Name",
      "address.error_company":
        "Only alphabets, Number and spaces are allowed for Company Name",
      "address.error_addressLine1":
        "Only alphabets, Number, spaces and commas are allowed for Address line 1",
      "address.error_addressLine2":
        "Only alphabets, Number, spaces and commas are allowed for Address line 2",
      "address.error_postalCode":
        "Only alphabets and Numbers are allowed for EIR Code",
      "address.error_city":
        "Only alphabets and spaces are allowed for City/Town",
      "address.error_county": "Only alphabets are allowed for County",
      "address.error_country":
        "Only alphabets and spaces are allowed for Country",
      "address.error_phone":
        "Please enter a valid phone number. Only numbers allowed.",
      "address.error_taxRegisterationNum":
        "Only alphabets and Numbers are allowed for Vat Registeration Number",
    },
    "en-AU": {
      "address.firstName": "First Name",
      "address.lastName": "Last Name",
      "address.company": "Company Name",
      "address.addressLine1": "Address line 1",
      "address.addressLine2": "Address line 2",
      "address.postalCode": "Postcode",
      "address.city": "City/Town",
      "address.county": "State",
      "address.country": "Country",
      "address.phone": "Phone Number",
      "address.taxRegisterationNum": "Vat Registration Number",
      "address.select": "Select",

      "address.error_firstName": "Only alphabets are allowed for First Name",
      "address.error_lastName": "Only alphabets are allowed for Last Name",
      "address.error_company":
        "Only alphabets, Number and spaces are allowed for Company Name",
      "address.error_addressLine1":
        "Only alphabets, Number, spaces and commas are allowed for Address line 1",
      "address.error_addressLine2":
        "Only alphabets, Number, spaces and commas are allowed for Address line 2",
      "address.error_postalCode":
        "Only alphabets and Numbers are allowed for EIR Code",
      "address.error_city":
        "Only alphabets and spaces are allowed for City/Town",
      "address.error_county": "Only alphabets are allowed for County",
      "address.error_country":
        "Only alphabets and spaces are allowed for Country",
      "address.error_phone":
        "Please enter a valid phone number. Only numbers allowed.",
      "address.error_taxRegisterationNum":
        "Only alphabets and Numbers are allowed for Vat Registeration Number",
    },
    "sk-SK": {
      "address.firstName": "Meno",
      "address.lastName": "Priezvisko",
      "address.company": "Názov spoločnosti",
      "address.addressLine1": "Adresa, riadok 1",
      "address.addressLine2": "Adresa, riadok 2",
      "address.postalCode": "PSČ",
      "address.city": "Mesto/obec",
      "address.county": "Región",
      "address.country": "Krajina",
      "address.phone": "Telefónne číslo",
      "address.taxRegisterationNum": "Registračné číslo DPH",
      "address.select": "Vybrať",

      "address.error_firstName": "Pre meno sú povolené iba znaky abecedy",
      "address.error_lastName": "Pre priezvisko sú povolené iba znaky abecedy",
      "address.error_company":
        "Pre názov spoločnosti sú povolené iba znaky abecedy, čísla a medzery",
      "address.error_addressLine1":
        "Pre 1. riadok adresy sú povolené iba znaky abecedy, čísla, medzery a čiarky",
      "address.error_addressLine2":
        "Pre 2. riadok adresy sú povolené iba znaky abecedy, čísla, medzery a čiarky",
      "address.error_postalCode":
        "Pre PSČ sú povolené iba znaky abecedy a čísla",
      "address.error_city":
        "Pre mesto/obec sú povolené iba znaky abecedy a medzery",
      "address.error_county": "Pre región sú povolené iba znaky abecedy",
      "address.error_country":
        "Pre krajinu sú povolené iba znaky abecedy a medzery",
      "address.error_phone":
        "Pre telefónne číslo sú povolené iba čísla, pričom minimálny počet znakov by mal byť 10",
      "address.error_taxRegisterationNum":
        "Pre registračné číslo DPH sú povolené iba znaky abecedy a čísla",
    },
    "hu-HU": {
      "address.firstName": "Utónév",
      "address.lastName": "Vezetéknév",
      "address.company": "Vállalat neve",
      "address.addressLine1": "Cím 1. sora",
      "address.addressLine2": "Cím 2. sora",
      "address.postalCode": "Irányítószám",
      "address.city": "Város/Település",
      "address.county": "Megye",
      "address.country": "Ország",
      "address.phone": "Telefonszám",
      "address.taxRegisterationNum": "Adószám",
      "address.select": "Kiválaszt",

      "address.error_firstName": "Az Utónév csak betűkből állhat",
      "address.error_lastName": "A Vezetéknév csak betűket tartalmazhat",
      "address.error_company":
        "A Vállalat neve csak betűkből, számokból és szóközökből állhat",
      "address.error_addressLine1":
        "A Cím 1. sora csak számokból, szóközökből és vesszőkből állhat",
      "address.error_addressLine2":
        "A Cím 2. sora csak számokból, szóközökből és vesszőkből állhat",
      "address.error_postalCode":
        "Az Irányítószám csak betűkből és számokból állhat",
      "address.error_city":
        "A Város/település csak betűkből és szóközökből állhat",
      "address.error_county": "A Megye mezőben csak betűk szerepelhetnek",
      "address.error_country": "A Megye csak betűkből és szóközökből állhat",
      "address.error_phone":
        "A Telefonszám mezőben csak számok szerepelhetnek, és legalább 10 karaktert kell tartalmaznia",
      "address.error_taxRegisterationNum":
        "Az Adószám csak betűkből és számokból állhat",
    },
    "fi-FI": {
      "address.firstName": "Etunimi",
      "address.lastName": "Sukunimi",
      "address.company": "Yrityksen nimi",
      "address.addressLine1": "Osoiterivi 1",
      "address.addressLine2": "Osoiterivi 2",
      "address.postalCode": "Postinumero",
      "address.city": "Postitoimipaikka",
      "address.county": "Lääni",
      "address.country": "Maa",
      "address.phone": "Puhelinnumero",
      "address.taxRegisterationNum": "Y-tunnus",
      "address.select": "Valitse",

      "address.error_firstName": "Etunimi-kohtaan saa syöttää vain aakkosia",
      "address.error_lastName": "Sukunimi-kohtaan saa syöttää vain aakkosia",
      "address.error_company":
        "Yrityksen nimi -kohtaan saa syöttää vain aakkosia, numeroita ja välilyöntejä",
      "address.error_addressLine1":
        "Osoiterivi 1 -kohtaan saa syöttää vain aakkosia, numeroita, välilyöntejä ja pilkkuja",
      "address.error_addressLine2":
        "Osoiterivi 2 -kohtaan saa syöttää vain aakkosia, numeroita, välilyöntejä ja pilkkuja",
      "address.error_postalCode":
        "Postinumero-kohtaan saa syöttää vain aakkosia ja numeroita",
      "address.error_city":
        "Postitoimipaikka-kohtaan saa syöttää vain aakkosia ja välilyöntejä",
      "address.error_county": "Lääni-kohtaan saa syöttää vain aakkosia",
      "address.error_country":
        "Maa-kohtaan saa syöttää vain aakkosia ja välilyöntejä",
      "address.error_phone":
        "Puhelinnumero-kohtaan saa syöttää vain numeroita, ja puhelinnumeron vähimmäispituus on 10",
      "address.error_taxRegisterationNum":
        "Y-tunnus-kohtaan saa syöttää vain aakkosia ja numeroita",
    },
    "en-US": {
      "address.firstName": "First Name",
      "address.lastName": "Last Name",
      "address.company": "Company Name",
      "address.addressLine1": "Address line 1",
      "address.addressLine2": "Address line 2",
      "address.postalCode": "Zip Code",
      "address.city": "City",
      "address.county": "State",
      "address.country": "Country",
      "address.phone": "Phone Number",
      "address.taxRegisterationNum": "Vat Registration Number",
      "address.select": "Select One",
      "address.extension": "Extension",
      "address.error_firstName": "Only alphabets are allowed for First Name",
      "address.error_lastName": "Only alphabets are allowed for Last Name",
      "address.error_company":
        "Only alphabets, Number and spaces are allowed for Company Name",
      "address.error_addressLine1":
        "Only alphabets, Number, spaces and commas are allowed for Address line 1",
      "address.error_addressLine2":
        "Only alphabets, Number, spaces and commas are allowed for Address line 2",
      "address.error_postalCode": "Please enter a valid zip code",
      "address.error_city":
        "Only alphabets and spaces are allowed for City/Town",
      "address.error_county": "Only alphabets are allowed for County",
      "address.error_country":
        "Only alphabets and spaces are allowed for Country",
      "address.error_phone":
        "Please enter a valid phone number. Only numbers allowed.",
      "address.error_extension":
        "Only alphabets and Numbers are allowed for Extension",
      "address.error_taxRegisterationNum":
        "Only alphabets and Numbers are allowed for Vat Registeration Number",
    },
    "en-CA": {
      "address.firstName": "First Name",
      "address.lastName": "Last Name",
      "address.company": "Company Name",
      "address.addressLine1": "Address line 1",
      "address.addressLine2": "Address line 2",
      "address.postalCode": "Postal Code",
      "address.city": "City",
      "address.county": "Province",
      "address.country": "Country",
      "address.phone": "Phone Number",
      "address.taxRegisterationNum": "Vat Registration Number",
      "address.select": "Select One",
      "address.extension": "Extension",
      "address.error_firstName": "Only alphabets are allowed for First Name",
      "address.error_lastName": "Only alphabets are allowed for Last Name",
      "address.error_company":
        "Only alphabets, Number and spaces are allowed for Company Name",
      "address.error_addressLine1":
        "Only alphabets, Number, spaces and commas are allowed for Address line 1",
      "address.error_addressLine2":
        "Only alphabets, Number, spaces and commas are allowed for Address line 2",
      "address.error_postalCode": "Please enter a valid postal code",
      "address.error_city":
        "Only alphabets and spaces are allowed for City/Town",
      "address.error_county": "Only alphabets are allowed for County",
      "address.error_country":
        "Only alphabets and spaces are allowed for Country",
      "address.error_phone":
        "Please enter a valid phone number. Only numbers allowed.",
      "address.error_extension":
        "Only alphabets and Numbers are allowed for Extension",
      "address.error_taxRegisterationNum":
        "Only alphabets and Numbers are allowed for Vat Registeration Number",
    },
  },

  country: {
    IE: {
      en: "Ireland",
      "en-IE": "Ireland",
      "pt-PT": "Irlanda",
      "es-ES": "Irlanda",
      "nl-BE": "Ierland",
      "fr-BE": "Irlande",
      "de-CH": "Irland",
      "fr-CH": "Irlande",
      "it-CH": "Irlanda",
      "en-GB": "Ireland",
      "de-DE": "Irland",
      "fr-FR": "Irlande",
      "it-IT": "Irlanda",
      "nl-NL": "Ierland",
      "de-AT": "Irland",
      "sv-SE": "Irland",
      "nn-NO": "Irland",
      "fi-FI": "Irlanti",
      "da-DK": "Irland",
      "cs-CZ": "Irsko",
      "sk-SK": "Írsko",
      "hu-HU": "Írország",
      "en-US": "Ireland",
      "ja-JP": "アイルランド",
      "en-NZ": "Ireland",
      "en-AU": "Ireland",
    },
    GB: {
      en: "United Kingdom",
      "en-IE": "United Kingdom",
      "pt-PT": "Reino Unido",
      "es-ES": "Reino Unido",
      "nl-BE": "Verenigd Koninkrijk",
      "fr-BE": "Royaume-Uni",
      "de-CH": "Vereinigtes Königreich",
      "fr-CH": "Royaume-Uni",
      "it-CH": "Regno Unito",
      "en-GB": "United Kingdom",
      "de-DE": "Vereinigtes Königreich",
      "fr-FR": "Royaume-Uni",
      "it-IT": "Regno Unito",
      "nl-NL": "Verenigd Koninkrijk",
      "de-AT": "Vereinigtes Königreich",
      "sv-SE": "Storbritannien",
      "nn-NO": "Storbritannia",
      "fi-FI": "Yhdistynyt kuningaskunta",
      "da-DK": "Det Forenede Kongerige",
      "cs-CZ": "Spojené Království",
      "sk-SK": "Anglicko",
      "hu-HU": "Egyesült Királyság",
      "en-US": "United Kingdom",
      "ja-JP": "イギリス",
      "en-NZ": "United Kingdom",
      "en-AU": "United Kingdom",
    },
    PT: {
      pt: "Portugal",
      "en-IE": "Portugal",
      "pt-PT": "Portugal",
      "es-ES": "Portugal",
      "nl-BE": "Portugal",
      "fr-BE": "Portugal",
      "de-CH": "Portugal",
      "fr-CH": "Portugal",
      "it-CH": "Portogallo",
      "en-GB": "Portugal",
      "de-DE": "Portugal",
      "fr-FR": "Portugal",
      "it-IT": "Portogallo",
      "nl-NL": "Portugal",
      "de-AT": "Portugal",
      "sv-SE": "Portugal",
      "nn-NO": "Portugal",
      "fi-FI": "Portugali",
      "da-DK": "Portugal",
      "cs-CZ": "Portugalsko",
      "sk-SK": "Portugalsko",
      "hu-HU": "Portugália",
      "en-US": "Portugal",
      "ja-JP": "ポルトガル",
      "en-NZ": "Portugal",
      "en-AU": "Portugal",
    },
    ES: {
      es: "España",
      "en-IE": "Spain",
      "pt-PT": "Espanha",
      "es-ES": "España",
      "nl-BE": "Spanje",
      "fr-BE": "Espagne",
      "de-CH": "Spanien",
      "fr-CH": "Espagne",
      "it-CH": "Spagna",
      "en-GB": "Spain",
      "de-DE": "Spanien",
      "fr-FR": "Espagne",
      "it-IT": "Spagna",
      "nl-NL": "Spanje",
      "de-AT": "Spanien",
      "sv-SE": "Spanien",
      "nn-NO": "Spania",
      "fi-FI": "espanja",
      "da-DK": "Spanien",
      "cs-CZ": "Španělsko",
      "sk-SK": "Španielsko",
      "hu-HU": "Spanyolország",
      "en-US": "Spain",
      "ja-JP": "スペイン",
      "en-NZ": "Spain",
      "en-AU": "Spain",
    },
    NL: {
      nl: "Nederland",
      "en-IE": "Netherlands",
      "pt-PT": "Países Baixos",
      "es-ES": "Países Bajos",
      "nl-BE": "Nederland",
      "fr-BE": "Pays-Bas",
      "de-CH": "Niederlande",
      "fr-CH": "Pays-Bas",
      "it-CH": "Olanda",
      "en-GB": "Netherlands",
      "de-DE": "Niederlande",
      "fr-FR": "Pays-Bas",
      "it-IT": "Olanda",
      "nl-NL": "Nederland",
      "de-AT": "Niederlande",
      "sv-SE": "Nederländerna",
      "nn-NO": "Nederland",
      "fi-FI": "Alankomaat",
      "da-DK": "Holland",
      "cs-CZ": "Nizozemsko",
      "sk-SK": "Holandsko",
      "hu-HU": "Hollandia",
      "en-US": "Netherlands",
      "ja-JP": "オランダ",
      "en-NZ": "Netherlands",
      "en-AU": "Netherlands",
    },
    BE: {
      nl: "België",
      fr: "Belgique",
      "en-IE": "Belgium",
      "pt-PT": "Bélgica",
      "es-ES": "Bélgica",
      "nl-BE": "Belgie",
      "fr-BE": "Belgique",
      "de-CH": "Belgien",
      "fr-CH": "Belgique",
      "it-CH": "Belgio",
      "en-GB": "Belgium",
      "de-DE": "Belgien",
      "fr-FR": "Belgique",
      "it-IT": "Belgio",
      "nl-NL": "Belgie",
      "de-AT": "Belgien",
      "sv-SE": "Belgien",
      "nn-NO": "Belgia",
      "fi-FI": "belgia",
      "da-DK": "Belgien",
      "cs-CZ": "Belgie",
      "sk-SK": "Belgicko",
      "hu-HU": "Belgium",
      "en-US": "Belgium",
      "ja-JP": "ベルギー",
      "en-NZ": "Belgium",
      "en-AU": "Belgium",
    },
    FR: {
      fr: "France",
      "en-IE": "France",
      "pt-PT": "França",
      "es-ES": "Francia",
      "nl-BE": "Frankrijk",
      "fr-BE": "France",
      "de-CH": "Frankreich",
      "fr-CH": "France",
      "it-CH": "Francia",
      "en-GB": "France",
      "de-DE": "Frankreich",
      "fr-FR": "France",
      "it-IT": "Francia",
      "nl-NL": "Frankrijk",
      "de-AT": "Frankreich",
      "sv-SE": "Frankrike",
      "nn-NO": "Frankriket",
      "fi-FI": "ranska",
      "da-DK": "Frankrig",
      "cs-CZ": "Francie",
      "sk-SK": "Francúzsko",
      "hu-HU": "Franciaország",
      "en-US": "France",
      "ja-JP": "フランス",
      "en-NZ": "France",
      "en-AU": "France",
    },
    CH: {
      fr: "Suisse",
      de: "Schweiz",
      it: "Svizzera",
      "en-IE": "Switzerland",
      "pt-PT": "Suíça",
      "es-ES": "Suiza",
      "nl-BE": "Zwitserland",
      "fr-BE": "Suisse",
      "de-CH": "Schweiz",
      "fr-CH": "Suisse",
      "it-CH": "Svizzera",
      "en-GB": "Switzerland",
      "de-DE": "Schweiz",
      "fr-FR": "Suisse",
      "it-IT": "Svizzera",
      "nl-NL": "Zwitserland",
      "de-AT": "Schweiz",
      "sv-SE": "Schweiz",
      "nn-NO": "Sveits",
      "fi-FI": "sveitsi",
      "da-DK": "Schweiz",
      "cs-CZ": "Švýcarsko",
      "sk-SK": "Švajčiarsko",
      "hu-HU": "Svájc",
      "en-US": "Switzerland",
      "ja-JP": "スイス",
      "en-NZ": "Switzerland",
      "en-AU": "Switzerland",
    },
    DE: {
      de: "Deutschland",
      "en-IE": "Germany",
      "pt-PT": "Alemanha",
      "es-ES": "Alemania",
      "nl-BE": "Duitsland",
      "fr-BE": "Allemagne",
      "de-CH": "Deutschland",
      "fr-CH": "Allemagne",
      "it-CH": "Germania",
      "en-GB": "Germany",
      "de-DE": "Deutschland",
      "fr-FR": "Allemagne",
      "it-IT": "Germania",
      "nl-NL": "Duitsland",
      "de-AT": "Deutschland",
      "sv-SE": "Tyskland",
      "nn-NO": "Tyskland",
      "fi-FI": "Saksa",
      "da-DK": "Tyskland",
      "cs-CZ": "Německo",
      "sk-SK": "Nemecko",
      "hu-HU": "Németország",
      "en-US": "Germany",
      "ja-JP": "ドイツ",
      "en-NZ": "Germany",
      "en-AU": "Germany",
    },
    DK: {
      da: "Danmark",
      "en-IE": "Denmark",
      "pt-PT": "Dinamarca",
      "es-ES": "Dinamarca",
      "nl-BE": "Denemarken",
      "fr-BE": "Danemark",
      "de-CH": "Dänemark",
      "fr-CH": "Danemark",
      "it-CH": "Danimarca",
      "en-GB": "Denmark",
      "de-DE": "Dänemark",
      "fr-FR": "Danemark",
      "it-IT": "Danimarca",
      "nl-NL": "Denemarken",
      "de-AT": "Dänemark",
      "sv-SE": "Danmark",
      "nn-NO": "Danmark",
      "fi-FI": "Tanska",
      "da-DK": "Danmark",
      "cs-CZ": "Dánsko",
      "sk-SK": "Dánsko",
      "hu-HU": "Dánia",
      "en-US": "Denmark",
      "ja-JP": "デンマーク",
      "en-NZ": "Denmark",
      "en-AU": "Denmark",
    },
    NO: {
      nn: "Norge",
      "en-IE": "Norway",
      "pt-PT": "Noruega",
      "es-ES": "Noruega",
      "nl-BE": "Noorwegen",
      "fr-BE": "Norvège",
      "de-CH": "Norwegen",
      "fr-CH": "Norvège",
      "it-CH": "Norvegia",
      "en-GB": "Norway",
      "de-DE": "Norwegen",
      "fr-FR": "Norvège",
      "it-IT": "Norvegia",
      "nl-NL": "Noorwegen",
      "de-AT": "Norwegen",
      "sv-SE": "Norge",
      "nn-NO": "Norge",
      "fi-FI": "Norja",
      "da-DK": "Norge",
      "cs-CZ": "Norsko",
      "sk-SK": "Nórsko",
      "hu-HU": "Norvégia",
      "en-US": "Norway",
      "ja-JP": "ノルウェー",
      "en-NZ": "Norway",
      "en-AU": "Norway",
    },
    SE: {
      se: "Sverige",
      "en-IE": "Sweden",
      "pt-PT": "Suécia",
      "es-ES": "Suecia",
      "nl-BE": "Zweden",
      "fr-BE": "Suède",
      "de-CH": "Schweden",
      "fr-CH": "Suède",
      "it-CH": "Svezia",
      "en-GB": "Sweden",
      "de-DE": "Schweden",
      "fr-FR": "Suède",
      "it-IT": "Svezia",
      "nl-NL": "Zweden",
      "de-AT": "Schweden",
      "sv-SE": "Sverige",
      "nn-NO": "Sverige",
      "fi-FI": "ruotsi",
      "da-DK": "Sverige",
      "cs-CZ": "Švédsko",
      "sk-SK": "Švédsko",
      "hu-HU": "Svédország",
      "en-US": "Sweden",
      "ja-JP": "スウェーデン",
      "en-NZ": "Sweden",
      "en-AU": "Sweden",
    },
    FI: {
      fi: "Suomi",
      "en-IE": "Finland",
      "pt-PT": "Finlândia",
      "es-ES": "Finlandia",
      "nl-BE": "Finland",
      "fr-BE": "Finlande",
      "de-CH": "Finnland",
      "fr-CH": "Finlande",
      "it-CH": "Finlandia",
      "en-GB": "Finland",
      "de-DE": "Finnland",
      "fr-FR": "Finlande",
      "it-IT": "Finlandia",
      "nl-NL": "Finland",
      "de-AT": "Finnland",
      "sv-SE": "Finland",
      "nn-NO": "Finland",
      "fi-FI": "Suomi",
      "da-DK": "Finland",
      "cs-CZ": "Finsko",
      "sk-SK": "Fínsko",
      "hu-HU": "Finnország",
      "en-US": "Finland",
      "ja-JP": "フィンランド",
      "en-NZ": "Finland",
      "en-AU": "Finland",
    },
    CZ: {
      cs: "Česká republika",
      "en-IE": "Czech Republic",
      "pt-PT": "República Checa",
      "es-ES": "Republica checa",
      "nl-BE": "Tsjechische Republiek",
      "fr-BE": "République Tchèque",
      "de-CH": "Tschechische Republik",
      "fr-CH": "République Tchèque",
      "it-CH": "Repubblica Ceca",
      "en-GB": "Czech Republic",
      "de-DE": "Tschechische Republik",
      "fr-FR": "République Tchèque",
      "it-IT": "Repubblica Ceca",
      "nl-NL": "Tsjechische Republiek",
      "de-AT": "Tschechische Republik",
      "sv-SE": "Tjeckien",
      "nn-NO": "Tsjekkia",
      "fi-FI": "Tsekin tasavalta",
      "da-DK": "Tjekkiet",
      "cs-CZ": "Česká republika",
      "sk-SK": "Česká republika",
      "hu-HU": "Csehország",
      "en-US": "Czech Republic",
      "ja-JP": "チェコリパブリック",
      "en-NZ": "Czech Republic",
      "en-AU": "Czech Republic",
    },
    AT: {
      de: "Österreich",
      "en-IE": "Austria",
      "pt-PT": "Áustria",
      "es-ES": "Austria",
      "nl-BE": "Oostenrijk",
      "fr-BE": "Autriche",
      "de-CH": "Österreich",
      "fr-CH": "Autriche",
      "it-CH": "Austria",
      "en-GB": "Austria",
      "de-DE": "Österreich",
      "fr-FR": "Autriche",
      "it-IT": "Austria",
      "nl-NL": "Oostenrijk",
      "de-AT": "Österreich",
      "sv-SE": "Österrike",
      "nn-NO": "Østerriket",
      "fi-FI": "Itävalta",
      "da-DK": "Østrig",
      "cs-CZ": "Rakousko",
      "sk-SK": "Rakúsko",
      "hu-HU": "Ausztria",
      "en-US": "Austria",
      "ja-JP": "オーストリア",
      "en-NZ": "Austria",
      "en-AU": "Austria",
    },
    IT: {
      it: "Italia",
      "en-IE": "Italy",
      "pt-PT": "Itália",
      "es-ES": "Italia",
      "nl-BE": "Italië",
      "fr-BE": "Italie",
      "de-CH": "Italien",
      "fr-CH": "Italie",
      "it-CH": "Italia",
      "en-GB": "Italy",
      "de-DE": "Italien",
      "fr-FR": "Italie",
      "it-IT": "Italia",
      "nl-NL": "Italië",
      "de-AT": "Italien",
      "sv-SE": "Italien",
      "nn-NO": "Italia",
      "fi-FI": "Italia",
      "da-DK": "Italien",
      "cs-CZ": "Itálie",
      "sk-SK": "Taliansko",
      "hu-HU": "Olaszország",
      "en-US": "Italy",
      "ja-JP": "イタリア",
      "en-NZ": "Italy",
      "en-AU": "Italy",
    },
    HU: {
      hu: "Magyarország",
      "en-IE": "Hungary",
      "pt-PT": "Hungria",
      "es-ES": "Hungría",
      "nl-BE": "Hongarije",
      "fr-BE": "Hongrie",
      "de-CH": "Ungarn",
      "fr-CH": "Hongrie",
      "it-CH": "Ungheria",
      "en-GB": "Hungary",
      "de-DE": "Ungarn",
      "fr-FR": "Hongrie",
      "it-IT": "Ungheria",
      "nl-NL": "Hongarije",
      "de-AT": "Ungarn",
      "sv-SE": "Ungern",
      "nn-NO": "Ungarn",
      "fi-FI": "Unkari",
      "da-DK": "Ungarn",
      "cs-CZ": "Maďarsko",
      "sk-SK": "Maďarsko",
      "hu-HU": "Magyarország",
      "en-US": "Hungary",
      "ja-JP": "ハンガリー",
      "en-NZ": "Hungary",
      "en-AU": "Hungary",
    },
    SK: {
      sk: "Slovenská republika",
      "en-IE": "Slovakia",
      "pt-PT": "Eslováquia",
      "es-ES": "Eslovaquia",
      "nl-BE": "Slowakije",
      "fr-BE": "Slovaquie",
      "de-CH": "Slowakei",
      "fr-CH": "Slovaquie",
      "it-CH": "Slovacchia",
      "en-GB": "Slovakia",
      "de-DE": "Slowakei",
      "fr-FR": "Slovaquie",
      "it-IT": "Slovacchia",
      "nl-NL": "Slowakije",
      "de-AT": "Slowakei",
      "sv-SE": "Slovakien",
      "nn-NO": "Slovakia",
      "fi-FI": "Slovakia",
      "da-DK": "Slovakiet",
      "cs-CZ": "Slovensko",
      "sk-SK": "Slovensko",
      "hu-HU": "Szlovákia",
      "en-US": "Slovakia",
      "ja-JP": "スロバキア",
      "en-NZ": "Slovakia",
      "en-AU": "Slovakia",
    },
    JP: {
      ja: "日本",
      "en-IE": "Japan",
      "pt-PT": "",
      "es-ES": "",
      "nl-BE": "",
      "fr-BE": "",
      "de-CH": "",
      "fr-CH": "",
      "it-CH": "",
      "en-GB": "Japan",
      "de-DE": "",
      "fr-FR": "",
      "it-IT": "",
      "nl-NL": "",
      "de-AT": "",
      "sv-SE": "Japan",
      "nn-NO": "Japan",
      "fi-FI": "",
      "da-DK": "",
      "cs-CZ": "",
      "sk-SK": "",
      "hu-HU": "Japán",
      "en-US": "Japan",
      "ja-JP": "日本",
      "en-NZ": "Japan",
      "en-AU": "Japan",
    },
    NZ: {
      en: "New Zealand",
      "en-IE": "New Zealand",
      "pt-PT": "",
      "es-ES": "",
      "nl-BE": "",
      "fr-BE": "",
      "de-CH": "",
      "fr-CH": "",
      "it-CH": "",
      "en-GB": "New Zealand",
      "de-DE": "",
      "fr-FR": "",
      "it-IT": "",
      "nl-NL": "",
      "de-AT": "",
      "sv-SE": "",
      "nn-NO": "",
      "fi-FI": "",
      "da-DK": "",
      "cs-CZ": "",
      "sk-SK": "",
      "hu-HU": "",
      "en-US": "New Zealand",
      "ja-JP": "",
      "en-NZ": "New Zealand",
      "en-AU": "New Zealand",
    },
    AU: {
      en: "Australia",
      "en-IE": "Australia",
      "pt-PT": "",
      "es-ES": "",
      "nl-BE": "",
      "fr-BE": "",
      "de-CH": "",
      "fr-CH": "",
      "it-CH": "",
      "en-GB": "Australia",
      "de-DE": "",
      "fr-FR": "",
      "it-IT": "",
      "nl-NL": "",
      "de-AT": "",
      "sv-SE": "",
      "nn-NO": "",
      "fi-FI": "",
      "da-DK": "",
      "cs-CZ": "",
      "sk-SK": "",
      "hu-HU": "",
      "en-US": "Australia",
      "ja-JP": "",
      "en-NZ": "Australia",
      "en-AU": "Australia",
    },
    US: {
      en: "United States of America",
      "en-IE": "United States of America",
      "pt-PT": "",
      "es-ES": "",
      "nl-BE": "",
      "fr-BE": "",
      "de-CH": "",
      "fr-CH": "",
      "it-CH": "",
      "en-GB": "United States of America",
      "de-DE": "",
      "fr-FR": "",
      "it-IT": "",
      "nl-NL": "",
      "de-AT": "",
      "sv-SE": "",
      "nn-NO": "",
      "fi-FI": "",
      "da-DK": "",
      "cs-CZ": "",
      "sk-SK": "",
      "hu-HU": "",
      "en-US": "United States of America",
      "ja-JP": "",
      "en-NZ": "United States of America",
      "en-AU": "United States of America",
    },
    CA: {
      en: "Canada",
      "en-IE": "Canada",
      "pt-PT": "",
      "es-ES": "",
      "nl-BE": "",
      "fr-BE": "",
      "de-CH": "",
      "fr-CH": "",
      "it-CH": "",
      "en-GB": "Canada",
      "de-DE": "",
      "fr-FR": "",
      "it-IT": "",
      "nl-NL": "",
      "de-AT": "",
      "sv-SE": "",
      "nn-NO": "",
      "fi-FI": "",
      "da-DK": "",
      "cs-CZ": "",
      "sk-SK": "",
      "hu-HU": "",
      "en-US": "Canada",
      "ja-JP": "",
      "en-NZ": "Canada",
      "en-AU": "Canada",
    },
  },
  addressSequenceProps_myAccount: {
    default: [
      "firstName",
      " ",
      "lastName",
      "<br>",
      "streetName?<br>",
      "additionalStreetInfo?<br>",
      "city,state",
      "<br>",
      "postalCode,country",
      "<br>",
      "phone",
    ],
    JP: [
      "country",
      "<br>",
      "postalCode",
      "<br>",
      "state,city",
      "<br>",
      "streetName?<br>",
      "additionalStreetInfo?<br>",
      "lastName",
      " ",
      "firstName",
      "<br>",
      "phone",
    ],
    HU: [
      "lastName",
      " ",
      "firstName",
      "<br>",
      "company?<br>",
      "city,state",
      "<br>",
      "streetName?<br>",
      "additionalStreetInfo?<br>",
      "postalCode",
      "<br>",
      "country",
      "<br>",
      "phone",
    ],
    US: [
      "firstName",
      " ",
      "lastName",
      "<br>",
      "streetName?<br>",
      "additionalStreetInfo?<br>",
      "city,state",
      " ",
      "postalCode",
      "<br>",
      "phone",
      " ",
      "extension",
    ],
    CA: [
      "firstName",
      " ",
      "lastName",
      "<br>",
      "streetName?<br>",
      "additionalStreetInfo?<br>",
      "city,state",
      " ",
      "postalCode",
      "<br>",
      "phone",
      " ",
      "extension",
    ],
  },
  addressSequenceProps_checkout: {
    default: [
      "firstName",
      " ",
      "lastName",
      "<br>",
      "company?<br>",
      "streetName",
      "<br>",
      "additionalStreetInfo?<br>",
      "city,state",
      "<br>",
      "postalCode?,",
      " ",
      "country",
      "<br>",
      "phone",
    ],
    JP: [
      "company?<br>",
      "country",
      "<br>",
      "postalCode",
      "<br>",
      "state,city",
      "<br>",
      "streetName?<br>",
      "additionalStreetInfo?<br>",
      "lastName",
      " ",
      "firstName",
      "<br>",
      "phone",
    ],
    HU: [
      "lastName",
      " ",
      "firstName",
      "<br>",
      "company?<br>",
      "city,state",
      "<br>",
      "streetName?<br>",
      "additionalStreetInfo?<br>",
      "postalCode",
      "<br>",
      "country",
      "<br>",
      "phone",
    ],
    US: [
      "firstName",
      " ",
      "lastName",
      "<br>",
      "company?<br>",
      "streetName",
      "<br>",
      "additionalStreetInfo?<br>",
      "city,state",
      " ",
      "postalCode?",
      "<br>",
      "phone",
      " ",
      "extension",
    ],
    CA: [
      "firstName",
      " ",
      "lastName",
      "<br>",
      "company?<br>",
      "streetName",
      "<br>",
      "additionalStreetInfo?<br>",
      "city,state",
      " ",
      "postalCode?",
      "<br>",
      "phone",
      " ",
      "extension",
    ],
  },
};
